import { Const } from '../lib/const.cls'

export const getters = {
    [Const.GET_IP_ADDRESS_LIST]: (state) => { return state.ipAddressList },
    // ======================= Login Info =========================
    [Const.GET_LOGIN_INFO]: (state) => { return state.loginInfo },

}


// WEBPACK FOOTER //
// ./src/plugins/userOperation/provider/store-addons/getters.js